export enum SliderStatusEnum {
  Active = 'active',
  Inactive = 'inactive'
}
